import { Button, Col, DatePicker, Form, Row, Table } from "antd";
import skuService from "../../../services/sku";
import grnService from "../../../services/grn";
import { Typography } from "antd";
import { useEffect, useState } from "react";
import saveAs from "file-saver";
import { DownloadOutlined } from "@ant-design/icons";
import dayjs, { Dayjs } from "dayjs";
import * as XLSX from "xlsx"; // Added import
const { Title } = Typography;
function GRNSummaryReport() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const handleLoad = async (values: { duration: [Dayjs, Dayjs] }) => {
    try {
      setLoading(true);
      // Use getGRNReport instead of grnService.reportSummary
      const data = await grnService.getSummaryReport(values.duration);
      setData(data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  const handleDownloadXlsx = () => {
    // Define headers matching AntD table
    const headers = [
      "ID", // Added header
      "PO ID",
      "Date",
      "Created By",
      "Vendor",
      "SKU Code", // Added header
      "Size", // Added header
      "Received Quantity",
      "Rejected Quantity",
      "Pending Quantity",
      "Ordered Quantity",
    ];

    // Transform data to match headers
    const transformedData = data.map((item) => ({
      ID: item.id, // Added field
      "PO ID": item.poId,
      Date: dayjs(item.date).format("DD-MM-YYYY"),
      "Created By": item.createdBy || "",
      Vendor: item.vendor,
      "SKU Code": item.skuCode, // Added field
      Size: item.size, // Added field
      "Received Quantity": item.receivedQuantity,
      "Rejected Quantity": item.rejectedQuantity,
      "Pending Quantity": item.pendingQuantity,
      "Ordered Quantity": item.orderedQuantity,
    }));

    const worksheet = XLSX.utils.json_to_sheet(transformedData, {
      header: headers,
    });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "GRNSummaryReport");
    const excelBuffer = XLSX.write(workbook, {
      type: "array",
      bookType: "xlsx",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "GRNSummaryReport.xlsx");
  };
  const columns = [
    { title: "ID", dataIndex: "id", key: "id" }, // Added column
    { title: "PO ID", dataIndex: "poId", key: "poId" },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (date) => dayjs(date).format("DD-MM-YYYY"),
    },
    { title: "Created By", dataIndex: "createdBy", key: "createdBy" },
    { title: "Vendor", dataIndex: "vendor", key: "vendor" },
    { title: "SKU Code", dataIndex: "skuCode", key: "skuCode" }, // Added column
    { title: "Size", dataIndex: "size", key: "size" }, // Added column
    {
      title: "Received Quantity",
      dataIndex: "receivedQuantity",
      key: "receivedQuantity",
    },
    {
      title: "Rejected Quantity",
      dataIndex: "rejectedQuantity",
      key: "rejectedQuantity",
    },
    {
      title: "Pending Quantity",
      dataIndex: "pendingQuantity",
      key: "pendingQuantity",
    },
    {
      title: "Ordered Quantity",
      dataIndex: "orderedQuantity",
      key: "orderedQuantity",
    },
  ];
  return (
    <div>
      <Row justify="space-between">
        <Col>
          <Title level={3}>GRN Summary Report</Title>
        </Col>
        <Col></Col>
        <Col></Col>
      </Row>
      <div>
        <Form form={form} onFinish={handleLoad}>
          <Form.Item label="Duration" name="duration">
            <DatePicker.RangePicker />
          </Form.Item>
          <Form.Item noStyle>
            <Button type="primary" htmlType="submit">
              Load
            </Button>
          </Form.Item>
        </Form>
      </div>
      <div className="mt-4">
        <div className="mb-3">
          {data.length > 0 && ( // Added conditional rendering
            <Button
              type="default"
              onClick={handleDownloadXlsx}
              icon={<DownloadOutlined />}
              className="ml-2"
            >
              Download as XLSX
            </Button>
          )}
        </div>
        <Table dataSource={data} columns={columns} />
      </div>
    </div>
  );
}

export default GRNSummaryReport;
